import React, { useEffect, useState, useCallback } from "react";
// import I18n from 'i18n-js';
import BulkLoadEntityFileInput from './file_input'
import { Label } from "reactstrap";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { Dropdown } from 'primereact/dropdown';
import useFilterRequestParams from "../../../../hooks/useFilterRequestParams";
import {
  Button,
} from 'reactstrap';

import { create } from "./axios";
import { index as indexAbstractEntities } from "../../../../abstract/entity/axios";
import { formatToCurrency } from "../../../../helper/form";
import { isAuthorizedCustomFieldToUser } from "../../../../helper/custom_field/helper";
import _ from "lodash-es";


const AbstractBulkLoadEntityForm = (props) => {
  const headers = _.concat(props.defaultHeaders, _.map(props.customFields, 'code'), 'controldoc_id');
  const customFields = props?.customFields;

  const [entities, setEntities] = useState([]);
  const [file, setFile] = useState({});
  const [disabledSubmitButton, setDisabledSubmitButton] = useState(true)
  const [updateEntities, setUpdateEntities] = useState(false);
  const [requestFilterParams, setRequestFilterParams] = useFilterRequestParams({});
  const [globalFilter, setGlobalFilter] = useState('');

  const { customer, securityLayers, currentEntityType, currentUser } = props;

  useEffect(() => {
    if (updateEntities) {
      setEntities(entities)
      setUpdateEntities(false)
    }
  }, [updateEntities])

  useEffect(() => {
    if (entities.length > 0) {
      setDisabledSubmitButton(false);
    } else {
      setDisabledSubmitButton(true);
    }
  }, [entities])

  const handleValues = (e, index, field, customField) => {
    let value = e.target ? e.target.value : e.value;
    let _entities = [...entities]

    if (customField && customField.data_type == 'currency') {
      value = formatToCurrency(value)
    }

    if (customField && customField.data_type == 'date') {
      value = moment(value, "YYYY-MM-DD").locale('es').format('DD/MM/YYYY')
    }

    _entities[index][field] = value;
    setEntities(_entities);
    setUpdateEntities(true)
  }

  useEffect(() => {
    _.each(currentEntityType.related_entity_types, function (entityType) {
      let _requestFilterParams = { ... { ...requestFilterParams }, current_entity_type_id: entityType?.id }
      requestFilterParams['filterrific']['show_all'] = true;

      indexAbstractEntities(_requestFilterParams, response => {
        entityType.entities = response?.data?.entities || []
      })
    })
  }, [])

  const handleDestroyRow = (rowNumber) => {
    swalWithBootstrap.fire({
      title: 'Eliminar fila',
      html: '¿Estás seguro de eliminar la fila?',
    }).then(result => {
      if (result.isConfirmed) {
        _.remove(entities, item => { return item.row == rowNumber });
        setUpdateEntities(true);
        swal.fire(
          "Eliminado!",
          "La fila ha sido eliminada correctamente",
          "success"
        )
      }
    })
  }

  const securityLayerOptions = () => {
    return _.map(securityLayers, security_layer => ({
      label: security_layer.name,
      value: security_layer.name
    }));
  }

  const customFieldSelectOptions = useCallback((listOptions) => {
    return listOptions.map((option) => ({
      label: option,
      value: option
    }));
  }, [])

  const renderSecurityLayerEditor = (options) => {
    return (
      <Dropdown
        value={options.value}
        options={securityLayerOptions()}
        onChange={(e) => {
          options.editorCallback(e.value);
          handleValues(e, options.rowIndex, options.field, "security_layer")
        }}
        placeholder="Seleccionar capa de seguridad"
      />
    );
  }

  const renderIdentifierEditor = (options) => {
    return (
      <InputText
        value={options.value}
        onChange={(e) => {
          options.editorCallback(e.target.value);
          handleValues(e, options.rowIndex, options.field, "identifier")
        }}
        placeholder="Ingrese identificador"
      />
    );
  }

  const renderRelatedEntityEditor = (options, entityType) => {
    const entityOptions = entityType.entities.map(entity => ({
      label: entity.name,
      value: entity.identifier
    }));

    return (
      <Dropdown
        value={options.value}
        options={entityOptions}
        onChange={(e) => options.editorCallback(e.value)}
        placeholder="Seleccionar entidad"
      />
    );
  }

  const renderCustomFieldEditor = (options, customField) => {
    if (customField.data_type === "list") {
      const optionsList = customFieldSelectOptions(customField.list_options);
      return (
        <Dropdown
          value={options.value}
          options={optionsList}
          onChange={(e) => options.editorCallback(e.value)}
          disabled={!isAuthorizedCustomFieldToUser(customField, currentUser)}
          placeholder={`Seleccionar ${customField.label}`}
        />
      );
    } else {
      return (
        <InputText
          value={options.value}
          onChange={(e) => {
            options.editorCallback(e.target.value);
            handleValues(e, options.rowIndex, options.field, customField)
          }}
          disabled={!isAuthorizedCustomFieldToUser(customField, currentUser)}
          placeholder={`Ingrese ${customField.label}`}
        />
      );
    }
  }

  const renderActions = (rowData) => {
    return (
      <div className="d-flex align-items-center justify-content-center">
        <Button
          color="danger"
          outline
          className="border-0"

          icon="fas fa-trash-alt"
          onClick={() => handleDestroyRow(rowData.row)}
        >
          <i className="fas fa-trash-alt" />
        </Button>
      </div>
    );
  }

  const renderHeader = () => {
    return (
      <div className="d-flex justify-content-end">
        <IconField iconPosition="left">
          <InputIcon className="fas fa-search" />
          <InputText value={globalFilter} onChange={(e) => setGlobalFilter(e.target.value)} placeholder="Búsqueda Por Palabras" />
        </IconField>
      </div>
    );
  };

  const editingRows = _.reduce(
    entities,
    (accumulator, entity) => ({
      ...accumulator,
      [entity.controldoc_id]: true
    }),
    {}
  );

  const drawNewEntitiesTable = () => {
    const header = renderHeader();

    if (entities.length > 0) {
      return (
        <div className="row pt-2">
          <div className="col-12">
            <Label>{I18n.t('abstract.bulk.load.entities.form.table.title')} ({`${entities?.length}`})</Label>

            <DataTable
              editingRows={editingRows}
              onRowEditChange={() => { }} // Si no se define entonces editingRows no funciona.
              header={header}
              value={entities}
              editMode="row"
              dataKey="controldoc_id"
              paginator
              rows={10}
              rowsPerPageOptions={[5, 10, 25, 50]}
              paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
              currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} registros"
              globalFilter={globalFilter}
              emptyMessage="No existen registros"
              scrollable
              scrollHeight="600px"
              className="p-datatable-striped"
            >
              {customer.security_layer && (
                <Column
                  field="security_layer"
                  header={I18n.t('activerecord.attributes.abstract/entity.security_layer')}
                  editor={(options) => renderSecurityLayerEditor(options)}
                  sortable
                  filter
                  showAddButton={false}
                  filterPlaceholder={`Buscar ${I18n.t('activerecord.attributes.abstract/entity.security_layer')}`}
                />
              )}
              <Column
                field="identifier"
                header={I18n.t('activerecord.attributes.abstract/entity.identifier')}
                editor={(options) => renderIdentifierEditor(options)}
                sortable
                filter
                showAddButton={false}
                filterPlaceholder={`Buscar ${I18n.t('activerecord.attributes.abstract/entity.identifier')}`}
              />
              {_.map(currentEntityType.related_entity_types, function (entityType) {
                return (
                  <Column
                    key={entityType.singular_name}
                    field={entityType.singular_name}
                    header={entityType.singular_name}
                    editor={(options) => renderRelatedEntityEditor(options, entityType)}
                    sortable
                    filter
                    showAddButton={false}
                    filterPlaceholder={`Buscar ${entityType.singular_name}`}
                  />
                );
              })}
              {_.map(customFields, function (customField) {
                const isAuthorizedCustomField = isAuthorizedCustomFieldToUser(customField, currentUser);

                return (
                  <Column
                    key={customField.code}
                    field={customField.code}
                    header={customField.label}
                    editor={(options) => renderCustomFieldEditor(options, customField)}
                    sortable={isAuthorizedCustomField}
                    filter={isAuthorizedCustomField}
                    showAddButton={false}
                    filterPlaceholder={`Buscar ${customField.label}`}
                  />
                );
              })}
              <Column
                field="row"
                header={I18n.t("actions.actions")}
                body={renderActions}
                style={{ width: '100px' }}
              />
            </DataTable>
          </div>
        </div >
      )
    }
  }

  const handleConfirmSubmit = () => {
    swalWithBootstrap.fire({
      title: `Realizar carga de ${currentEntityType.plural_name}`,
      html: `¿Estás seguro de realizar la carga masiva de ${currentEntityType.plural_name}?`,
    }).then(result => {
      if (result.isConfirmed) {
        handleSubmit()
      }
    })
  }

  const handleSubmit = () => {
    let formData = getFormData();
    create(currentEntityType.hashid, formData, response => {
      if (response.status == 201) {
        window.location = Routes.abstract_bulk_load_entity_path(currentEntityType.hashid, response.data.hashid);
      } else {
        console.error("Problema al guardar la carga masiva abstracta")
      }
    })
  }

  const getFormData = () => {
    let formData = new FormData();
    formData.append("abstract_bulk_load_entity[file]", file || "");

    _.each(entities, function (entity) {
      formData.append("abstract_bulk_load_entity[items_attributes][][controldoc_id]", entity?.controldoc_id || "");
      formData.append("abstract_bulk_load_entity[items_attributes][][identifier]", entity?.identifier || "");
      formData.append("abstract_bulk_load_entity[items_attributes][][security_layer]", entity?.security_layer || "");

      _.each(currentEntityType.related_entity_types, function (relatedEntityType) {
        formData.append("abstract_bulk_load_entity[items_attributes][][config_entities][]", entity[relatedEntityType.singular_name])
      })

      _.each(customFields, function (customField) {
        formData.append(`abstract_bulk_load_entity[items_attributes][][custom_fields][${customField.code}]`, entity[customField.code]);
      })
    })

    return formData
  }

  return (
    <div className="row">
      <div className="col-12">
        <BulkLoadEntityFileInput
          currentEntityType={currentEntityType}
          headers={headers}
          customFields={customFields}
          setEntities={setEntities}
          setFile={setFile}
        />

        {drawNewEntitiesTable()}
      </div>

      <div className="col-12">
        <div className="text-end">
          <a
            href={Routes.abstract_bulk_load_entities_path(currentEntityType.hashid)}
            className="btn btn-default"
          >
            {I18n.t("actions.back")}
          </a>

          <Button
            color="success"
            className="ml-2"
            onClick={handleConfirmSubmit}
            disabled={disabledSubmitButton}
          >
            {I18n.t("actions.save")}
          </Button>
        </div>
      </div>
    </div>
  )
}

export default AbstractBulkLoadEntityForm;
